import React, {useContext} from "react";
import {Avatar, Box} from "@mui/material";

import {userInfoContext} from "../../App";

import "../../style/profileCard.css";
import {Link} from "react-router-dom";

export default function ProfileCard() {
    const [userInfo] = useContext(userInfoContext);

    return (
        <div className="right-side-cards-container profile-card">
            <div className="profile-header">
                <Box my={2}>
                    <Avatar
                        variant="circular"
                        className="profile-image"
                        src={userInfo.ImageUrl ? userInfo.ImageUrl : "no-profile-image.png"}
                        alt="Profile"
                        sx={{width: 55, height: 55}}
                    />
                </Box>
                {/* <img src={userInfo.imageUrl} alt="Profile" className="profile-image" /> */}
                <div className="profile-info">
                    <h3 className="profile-name">{userInfo.Name}</h3>
                    {EmailAndNameContainer(userInfo.Email, userInfo.Phone)}
                </div>
            </div>
            {/* <p className="profile-description">{userInfo.Description}</p> */}
            <Link to="/editprofile">
                <button className="edit-profile-button">Rediger profil</button>
            </Link>
        </div>
    );
}

function EmailAndNameContainer(email: string, phone: string) {
    const isLong = email ? email.length > 30 : false;

    return (
        <div className={isLong ? 'long-emails' : ''}>
            <p className={`profile-email`}>{email}</p>
            <p className={`profile-phone`}>{phone ? phone : "Mangler mobilnummer"}</p>

        </div>

    )
}
